import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useAuthContext } from '@/contexts/AuthContext';
import { NotificationBell } from '@/components/common/NotificationBell';

/**
 * Pill no estilo do design system (.ph-user) com avatar + nome + role.
 * Clica para abrir a página de perfil (/meu-perfil). O logout vive no
 * rodapé da sidebar.
 */
export function UserMenu() {
  const { t } = useTranslation();
  const { profile, isAdmin, isPrestador } = useAuthContext();

  const inicial = profile?.nome?.charAt(0)?.toUpperCase() || '?';
  const role = isAdmin
    ? t('common.role.admin')
    : isPrestador
      ? t('common.role.prestador')
      : t('common.role.atendente');

  return (
    <div className="flex items-center gap-2">
      <NotificationBell />
      <Link
        to="/meu-perfil"
        className="ph-user"
        aria-label={t('myProfile.title')}
        title={t('myProfile.title')}
      >
      <span
        className="cli-itm__avt-img"
        style={{ width: 32, height: 32, fontSize: 12 }}
      >
        {profile?.avatar_url ? (
          <img src={profile.avatar_url} alt={profile.nome || ''} />
        ) : (
          inicial
        )}
      </span>
      <span className="ph-user__info hidden sm:flex">
        <span className="ph-user__name">{profile?.nome || t('common.user')}</span>
        <span className="ph-user__role">{role}</span>
      </span>
      </Link>
    </div>
  );
}
